import { ChemicalRobLocationDDBM } from '../../types/BusinessModel/TankCleaning/ChemicalRobLocationDDBM';
import { ChemicalRobLocationDDItemBM } from '../../types/BusinessModel/TankCleaning/ChemicalRobLocationDDItemBM';
import { ChemicalRobLocationDD } from '../../types/ViewModel/TankCleaning/ROB/ChemicalRobLocationDD';
import { ChemicalRobLocationDDItem } from '../../types/ViewModel/TankCleaning/ROB/ChemicalRobLocationDDItem';

export const createRobLocationDD = (chemicalRobLocationDDBM: ChemicalRobLocationDDBM): ChemicalRobLocationDD => {
    return {
        robLocationDropdownId: chemicalRobLocationDDBM.robLocationDropdownId,
        name: chemicalRobLocationDDBM.name,
        robLocationDropdownItemList: createRobLocationDDItemList(chemicalRobLocationDDBM.robLocationDropdownItemList),
    };
};

export const createRobLocationDDList = (chemicalRobLocationDDBM: ChemicalRobLocationDDBM[]) =>
    chemicalRobLocationDDBM.map((chemicalRobLocationDDBM) => createRobLocationDD(chemicalRobLocationDDBM));

export const createRobLocationDDItem = (chemicalRobLocationDDItemBM: ChemicalRobLocationDDItemBM): ChemicalRobLocationDDItem => {
    return {
        robLocationDropdownId: chemicalRobLocationDDItemBM.robLocationDropdownId,
        robLocationDropdownItemId: chemicalRobLocationDDItemBM.robLocationDropdownItemId,
        name: chemicalRobLocationDDItemBM.name,
    };
};

export const createRobLocationDDItemList = (chemicalRobLocationDDItemList: ChemicalRobLocationDDItemBM[]) =>
    chemicalRobLocationDDItemList.map((chemicalRobLocationDDItem) => createRobLocationDDItem(chemicalRobLocationDDItem));
